import { AlignmentType, BorderStyle, HeadingLevel, ImageRun, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, TextWrappingSide, TextWrappingType, VerticalAlign, WidthType } from "docx";

export const summaryHeading = new Paragraph({
    spacing: { before: 150, after: 300 },
    children: [new TextRun({
        text: "5.  Executive Summary",
        bold: true
    })],
    heading: HeadingLevel.HEADING_2,
})

export function summeryPage(certInCustomerName, certInApplicationName) {
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { line: 276, before: 450, after: 300 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: certInCustomerName + " " + "engaged ISECURION for performing Web Application Security Audit of their" + " " + certInApplicationName + " " + "Web Application.",
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
        ],
    })
}

export function summaryBulletOne(certInEndDate, certInStartDate) {
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        function getOrdinalSuffix(day) {
            if (day > 3 && day < 21) return 'th';
            else {
                switch (day % 10) {
                    case 1: return 'st';
                    case 2: return 'nd';
                    case 3: return 'rd';
                    default: return 'th';
                }
            }
        }
        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const formattedDate = `${date.getDate()}`;
        const ordinalSuffix = getOrdinalSuffix(date.getDate());
        const formatMonth = monthNames[date.getMonth()];
        const formatYear = date.getFullYear();

        return {
            formattedDate,
            ordinalSuffix,
            formatMonth,
            formatYear
        };
    };

    const formattedStartDate = formatDate(certInStartDate);
    const formattedEndDate = formatDate(certInEndDate);

    return new Paragraph({
        indent: { left: 600 },
        bullet: { level: 0 },
        spacing: { line: 350, after: 10 * 72 * 0.05 },
        children: [
            new TextRun({
                text: "The Stage 1 Security Audit was executed from",
                size: 22,
                font: "Calibri",
                bullet: { level: 0 },
                color: '000000',
                italics: false
            }),
            new TextRun({
                text: ' ' + formattedStartDate.formattedDate,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),

            new TextRun({
                text: formattedStartDate.ordinalSuffix,
                superScript: true,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
            new TextRun({
                text: ' ' + formattedStartDate.formatMonth + ' ' + formattedStartDate.formatYear + ' ',
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
            new TextRun({
                text: 'to',
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
            new TextRun({
                text: ' ' + formattedEndDate.formattedDate,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
            new TextRun({
                text: formattedEndDate.ordinalSuffix,
                superScript: true,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
            new TextRun({
                text: ' ' + formattedEndDate.formatMonth + ' ' + formattedEndDate.formatYear + ' ',
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),

        ]
    })
}


export const SummaryNote = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 1000, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "NOTE:",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false,
            bold: true
        }),
    ],
})

export function sumaryNote1(certInAppEnvironment, certInTestingype) {
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { line: 276, before: 250, after: 300 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: "Testing was performed on the" + ' ' + certInAppEnvironment + ' ' + "Environment." + ' ' + certInTestingype + ' ' + (certInTestingype === "Black box testing methodology (Unauthenticated Testing)" ? "was performed." : "was performed with below-mentioned user role:"),
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
        ],
    })
}

export function noteUserRoles(certInRoles) {
    const names = Array.isArray(certInRoles) ? certInRoles : [];

    const rows = [
        new TableRow({
            children: [
                new TableCell({
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                    children: [new Paragraph({
                        spacing: { before: 1, after: 1 },
                        alignment: AlignmentType.CENTER,
                        children: [new TextRun({
                            text: "",
                            font: "Calibri",
                            size: 26,
                            color: '0f0f3f',
                            italics: false
                        })]
                    })],
                }),
                new TableCell({
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                    children: [new Paragraph({
                        spacing: { before: 10, after: 10 },
                        alignment: AlignmentType.LEFT,
                        children: [new TextRun({
                            text: "",
                            font: "Calibri",
                            size: 24,
                            color: '0f0f3f',
                            italics: false
                        })]
                    })],
                }),
            ]
        })
    ];

    names.forEach((name) => {
        rows.push(
            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 5, type: WidthType.PERCENTAGE },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        },
                        children: [new Paragraph({
                            spacing: { before: 60, after: 60 },
                            alignment: AlignmentType.CENTER,
                            children: [new TextRun({
                                text: "\u2022",
                                font: "Calibri",
                                size: 26,
                                color: '0f0f3f',
                                italics: false
                            })]
                        })],
                    }),
                    new TableCell({
                        width: { size: 30, type: WidthType.PERCENTAGE },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        },
                        children: [new Paragraph({
                            spacing: { before: 60, after: 60 },
                            alignment: AlignmentType.LEFT,
                            children: [new TextRun({
                                text: name,
                                font: "Calibri",
                                size: 22,
                                color: '000000',
                                italics: false
                            })]
                        })],
                    }),
                ]
            })
        );
    });


    return new Table({
        width: { size: 35, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.LEFT,
        indent: { size: 600, type: WidthType.DXA },
        borders: {
            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        },
        rows: rows
    });
}

export const SummaryRecommendation = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 850, after: 300 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "It is recommended to:",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false,
            bold: true
        }),
    ],
})

export const recommendationBulletOne = new Paragraph({
    indent: { left: 600 },
    bullet: { level: 0 },
    spacing: { line: 350, after: 10 * 72 * 0.05 },
    children: [
        new TextRun({
            text: "Ensure that all vulnerabilities are fixed.",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})

export const recommendationBulletTwo = new Paragraph({
    indent: { left: 600 },
    bullet: { level: 0 },
    spacing: { line: 350, after: 10 * 72 * 0.05 },
    children: [
        new TextRun({
            text: "As part of an effective organizational risk management strategy, vulnerability assessments & penetration test should be conducted on regular basis.",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})
